export const blackText = `#141823`;
export const desireRed = `#ea3c53`;
export const pearlDiver = `#d9dddc`;
